import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getFGStock
} from "../../api/fgInventoryApi";

import {
  FaBoxes,
  FaSearch
} from "react-icons/fa";

const FinishedGoodsStock = () => {

  const [stocks,setStocks] =
  useState([]);

  const [search,setSearch] =
  useState("");

  const [loading,setLoading] =
  useState(true);

  useEffect(()=>{

    loadStock();

  },[]);

  const loadStock =
  async()=>{

    try{

      const res =
      await getFGStock();

      setStocks(
        res.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }
    finally{

      setLoading(false);

    }

  };

  const filteredStock =
  stocks.filter(
    item=>

      item.product_name
      ?.toLowerCase()
      .includes(
        search.toLowerCase()
      )

  );

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white">

          <div className="d-flex justify-content-between align-items-center">

            <div>

              <h5 className="mb-0">

                <FaBoxes className="me-2 text-primary" />

                Finished Goods Stock

              </h5>

              <small className="text-muted">

                Live Finished Goods Inventory

              </small>

            </div>

          </div>

        </div>

        <div className="card-body">

          <div className="row mb-3">

            <div className="col-md-4">

              <div className="input-group">

                <span className="input-group-text">

                  <FaSearch />

                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Product"
                  value={search}
                  onChange={(e)=>
                    setSearch(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

          </div>

          <div className="table-responsive">

            <table className="table table-hover align-middle">

              <thead className="table-light">

                <tr>

                  <th>
                    Product Code
                  </th>

                  <th>
                    Product Name
                  </th>

                  <th>
                    Available Stock
                  </th>

                  <th>
                    Status
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  loading
                  ?
                  (
                    <tr>

                      <td
                        colSpan="4"
                        className="text-center"
                      >

                        Loading...

                      </td>

                    </tr>
                  )
                  :
                  filteredStock.length > 0
                  ?
                  (
                    filteredStock.map(
                      item=>(

                        <tr
                          key={item.id}
                        >

                          <td>

                            <strong>

                              {
                                item.product_code ||
                                `FG-${item.id}`
                              }

                            </strong>

                          </td>

                          <td>

                            {
                              item.product_name
                            }

                          </td>

                          <td>

                            <span
                              className={
                                Number(item.stock) > 0
                                ?
                                "badge bg-success fs-6"
                                :
                                "badge bg-danger fs-6"
                              }
                            >

                              {
                                Number(
                                  item.stock || 0
                                ).toFixed(2)
                              }

                            </span>

                          </td>

                          <td>

                            {
                              Number(item.stock) > 0
                              ?
                              (
                                <span className="badge bg-success">

                                  In Stock

                                </span>
                              )
                              :
                              (
                                <span className="badge bg-danger">

                                  Out Of Stock

                                </span>
                              )
                            }

                          </td>

                        </tr>

                      )
                    )
                  )
                  :
                  (
                    <tr>

                      <td
                        colSpan="4"
                        className="text-center text-muted"
                      >

                        No Finished Goods Found

                      </td>

                    </tr>
                  )
                }

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </MainLayout>

  );

};

export default FinishedGoodsStock;